import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import AdvancedAlertsPage, { getDefaultPageUI } from "components/pages/AdvancedAlertsPage";
import SelectAccountContent from "components/pages/AdvancedAlertsPage/components/SelectAccountContent";
import Classes from "model";
import { useEffect } from "react";
import Util from "classes/Util";

export default function CaptureNotifiLegacySelectAccount(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);
    const { branding } = context.state;

    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI())
    // Sets the component to be used for the content
    .update([ "content" ], SelectAccountContent)
    .submit();

    useEffect(() => {
        Util.replaceDOMDataPointValues(branding);
    });
    
    return <AdvancedAlertsPage ui={ ui } />
}